const BASE_PROGRAM_OPTIONS = [
  {
    value: 'data_science',
    label: 'Scaler Data Science Program'
  },
  {
    value: 'ai_ml',
    label: 'Scaler AI/ML Program'
  },
  {
    value: 'software_development',
    label: 'Scaler Academy (Software Development)'
  },
  {
    value: 'devops',
    label: 'Scaler DevOps Program'
  },
  // 'fde' is the PROGRAM value. The Forward Deployed Engineer *target role* uses a
  // DISTINCT value ('fde-role') on purpose — this list feeds PROGRAM_OPTION_VALUES,
  // which sanitizeProgramSelections() uses to strip quiz answers whose value is a
  // program value. Role and program values must never collide, or the role gets stripped.
  {
    value: 'fde',
    label: 'Scaler Forward Deployed Engineering Program'
  }
];

export const PROGRAM_OPTION_VALUES = new Set(
  BASE_PROGRAM_OPTIONS.map((option) => option.value)
);
